import { User } from './auth';

export type Role = 'clinician' | 'group_admin' | 'platform_admin';

export type Permission =
  | 'view_clinicians'
  | 'manage_clinicians'
  | 'view_analytics'
  | 'manage_analytics'
  | 'view_billing'
  | 'manage_billing'
  | 'manage_webhooks'
  | 'manage_integrations'
  | 'manage_group_settings'
  | 'manage_platform_settings';

export interface RolePermissions {
  clinician: Permission[];
  group_admin: Permission[];
  platform_admin: Permission[];
}

export const DEFAULT_ROLE_PERMISSIONS: RolePermissions = {
  clinician: [
    'view_clinicians',
    'view_analytics',
    'view_billing',
  ],
  group_admin: [
    'view_clinicians',
    'manage_clinicians',
    'view_analytics',
    'manage_analytics',
    'view_billing',
    'manage_billing',
    'manage_webhooks',
    'manage_integrations',
    'manage_group_settings',
  ],
  platform_admin: [
    'view_clinicians',
    'manage_clinicians',
    'view_analytics',
    'manage_analytics',
    'view_billing',
    'manage_billing',
    'manage_webhooks',
    'manage_integrations',
    'manage_group_settings',
    'manage_platform_settings',
  ],
};